interface StatusBadgeProps {
  /** Semver string of the current head (e.g. "1.2.0"). */
  version: string;
}

/**
 * Neutral version chip — shows `v{version}`. There is no longer a draft/published
 * distinction in the UX; versioning is automatic and invisible to the editor.
 */
export function StatusBadge({ version }: StatusBadgeProps): JSX.Element {
  return (
    <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-xs font-medium text-slate-700">
      v{version}
    </span>
  );
}
